// Module
var code = "<p class=\"lead\">You can drag and drop these images:</p> <demo-flip></demo-flip> <pre class=\"lang-ts\"><code>{{ demoFlipTs }}</code></pre> ";
// Exports
export default code;